import { Component, Input, OnInit } from '@angular/core';
import { FormControl, FormGroup } from '@angular/forms';
import { Step8 } from '../../../../shared/models/component-messages/mapaIN/step8';
import { TypeJustif } from '../models/TypeJustif';
import { ArrayPopTools } from '../../../../shared/services/array-pop-tools';
import { JustificationsService } from '../service/justifications/justifications.service';
import { BehaviorSubject } from 'rxjs';
import { RadioCheckBoxEnum } from '../../../common/radio.checkbox.enums';
import { CTRL_CHIPS } from '../../../validators/newRG/CHIPS/ctrlCHIPS';
import { QualificationsProfessionnelles } from '../models/QualificationsProfessionnelles';
import { ConformiteFournitures } from '../models/ConformiteFournitures';
import { AutorisationSpecifique } from '../models/AutorisationSpecifique';

@Component({
  selector: 'app-type-justif',
  templateUrl: './type-justif.component.html',
  styleUrls: ['./type-justif.component.scss']
})
export class TypeJustifComponent implements OnInit {

  @Input() uid = '';
  public current_uid = 'TypeJustif';
  @Input() parentForm: FormGroup;
	@Input() disabled: boolean;

	@Input() justifications: TypeJustif;

  public step8 = new Step8();

  public rg1 = CTRL_CHIPS.id+ '_1';

  private docJointConsultation ='Les documents à produire sont ceux joints à la consultation';

  constructor(private justificationService :JustificationsService) { }

  public ngOnInit() {
   this.parentForm.addControl(this.getStepId() + this.rg1, new FormControl({ rgCtrls: this.getCtrl_CHIPSNames_json() }));
  }


  qualificationsProfessionnelles(){
    const checked = this.parentForm.controls[this.getUid() + '_SepAtt_qualificationsProfessionnellesCB']?.value;
    if (checked && !this.justifications.qualificationsProfessionnelles) {
      this.justifications.qualificationsProfessionnelles = new QualificationsProfessionnelles();
    }
		return checked;
  }

  conformiteFournitures(){
    const checked = this.parentForm.controls[this.getUid() + '_SepAtt_conformiteFournituresCB']?.value;
    if (checked && !this.justifications.conformiteFournitures) {
      this.justifications.conformiteFournitures = new ConformiteFournitures();
    }
		return checked;
  }

  autorisationSpecifique(){
    const checked = this.parentForm.controls[this.getUid() + '_SepAtt_autorisationSpecifiqueCB']?.value;
    if (checked && !this.justifications.autorisationSpecifique) {
      this.justifications.autorisationSpecifique = new AutorisationSpecifique();
    }
		return checked;
  }

  isJustificationAutre(){
    if (this.parentForm.controls[this.getUid() + '_SepAtt_justificationAutreCB']?.value && (this.justifications.justificationAutre === null || this.justifications.justificationAutre === undefined)) {
      this.justifications.justificationAutre = [];
    } else if (!this.parentForm.controls[this.getUid() + '_SepAtt_justificationAutreCB']?.value) {
      this.justifications.justificationAutre = null;
    }
		return this.parentForm.controls[this.getUid() + '_SepAtt_justificationAutreCB']?.value;
  }


  isDocConsultation() {
    if (this.justifications.justificationComment === undefined || this.justifications.justificationComment === null) {
      this.justifications.justificationComment = RadioCheckBoxEnum.emptyValue ;
    }
    if (this.parentForm.controls[this.getUid() + '_SepAtt_docsConsultation']?.value) {
      if (this.parentForm.controls[this.getUid() + '_SepAtt_justificationComment']?.value === RadioCheckBoxEnum.emptyValue
        && this.justifications.justificationComment === RadioCheckBoxEnum.emptyValue
        && !this.justifications.justificationComment.includes(this.docJointConsultation)) {
       this.justifications.justificationComment = this.docJointConsultation;
      }
    } else if (this.parentForm.controls[this.getUid() + '_SepAtt_docsConsultation']?.value === false
       && this.justifications.justificationComment === this.docJointConsultation) {
        this.justifications.justificationComment = "";
    }
    this.justificationService.setComment(this.justifications.justificationComment);
    return true;
  }


  getUid() {
    return this.uid + '_SepSep_' + this.current_uid;
  }

  getCtrl_CHIPSNames_json() {
    return { autresRenseignements: "_SepSep_Initial_SepSep_TypeJustif_SepAtt_justificationAutre"};
  }

  getStepId() {
		return this.uid.substring(0, this.uid.indexOf("SepSep"));
	}



}

